export default {
  "title": {
    "evolution": "Eventos de sonolência / 100h dirigindo diariamente",
    "quantityEvolution": "Número diário de eventos de sonolência",
    "totalEvents": "Total de eventos de sonolência",
    "ranking": "Classificação do piloto"
  },
  "labels": {
    "microsleepsKpi": "Eventos de sonolência / 100h de condução",
    "totalMicrosleeps": "Total de eventos de sonolência",
    "graphTooltip": "Eventos de sonolência"
  }
};


// WEBPACK FOOTER //
// ./source/client/components/locales/language_configuration/portuguese/road_warning/detailRoadWarning.js